module.exports = {
      id: "authoruser-usage",
      viewBox: "0 0 250 250",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#authoruser",
      toString: function () {
        return this.url;
      }
    }